import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaTimbresTimbreEditar', {
    template: template,
    controller: NominaTimbresTimbreEditarComponent,
    bindings: {
      data: '<',
      onClose: '&',
    },
  })

function NominaTimbresTimbreEditarComponent(NominaTimbresTimbre) {
  let $ctrl = this

  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.promise = NominaTimbresTimbre.get($ctrl.data.id_nomina, $ctrl.data.id_empresa, $ctrl.data.id_empleado, $ctrl.data.indice)
      .then(function (response) {
        $ctrl.data = response.data
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/timbre/editar/component.js